// src/utils/index.ts
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs))
}

export const createPageUrl = (pageName: string): string => {
    return `/${pageName.toLowerCase()}`
}

export const formatDate = (date: string | Date | null | undefined): string => {
    if (!date) return '-'
    return new Intl.DateTimeFormat('it-IT', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(date))
}
